export default __webpack_public_path__ + "static/quartermaster_logo-2ba6994f8de9ebbcac92ef3516904059.svg";